export const LOADING_BAR_HEIGHT = 6;
export const LOADING_BAR_STATUS_SECONDS = 0.75;
